import * as React from "react";
import { Plural } from "@lingui/macro";
import { Supportive } from "@conserveit/blocks";
import { getActionsAssociatedState } from "../../utils";

const SiteGroupRow: React.FunctionComponent<
  Insite.Insights.ComposedInsight & { showSnoozed: boolean }
> = (props) => {
  const {
    latestLabel,
    priority,
    severity,
    ruleName,
    ruleType,
    hits,
    activeHits,
    averageDur,
    activeAverageDur,
    actionsCount,
    showSnoozed,
  } = props;

  const displayHits = showSnoozed ? hits : activeHits;
  const displayAverageDur = showSnoozed ? averageDur : activeAverageDur;

  const { Cell, MainText, allAssociated, displayTargetCount } =
    getActionsAssociatedState(props, showSnoozed);

  return (
    <React.Fragment>
      <Cell>
        <MainText>{latestLabel}</MainText>
      </Cell>
      <Cell>
        <MainText>{priority === 0 ? "" : priority}</MainText>
      </Cell>
      <Cell>
        <MainText>{severity}</MainText>
      </Cell>
      <Cell>
        <MainText>{ruleName}</MainText>
      </Cell>
      <Cell>
        <MainText>{ruleType}</MainText>
      </Cell>
      <Cell>
        <MainText>
          {allAssociated ? (
            `All Associated (${displayTargetCount})`
          ) : (
            <Plural
              value={displayTargetCount}
              one={`${displayTargetCount} Equip`}
              other={`${displayTargetCount} Equips`}
            />
          )}
        </MainText>
        {actionsCount > 0 && <Supportive>{actionsCount} Associated</Supportive>}
      </Cell>
      <Cell>
        <MainText>
          <Plural
            value={displayHits}
            one={`${displayHits} Hit`}
            other={`${displayHits} Hits`}
          />
        </MainText>
        <Supportive>Avg. {displayAverageDur}hrs</Supportive>
      </Cell>
    </React.Fragment>
  );
};

export default React.memo(SiteGroupRow);
